import { CaretDownFilled, CaretUpFilled, InfoCircleOutlined, LineOutlined } from "@ant-design/icons";
import CustomTooltip from "@pages/tool-tip";
import React from "react";
import { Factors } from "../factors";
import { Risk as RiskType } from "../useRisks";
import './risk.scss';

const statusSymbols = {
  increase: <CaretUpFilled />,
  decrease: <CaretDownFilled />,
  same: <LineOutlined />
}

export const Risk: React.FC<{risk: RiskType, expanded: boolean}> = function ({ risk, expanded }) {
  return <div className="ui-risk">
    <div className="ui-risk__main">
      <div className="ui-risk__main__title">
        {risk.name}
        <CustomTooltip toolTipvalue={risk.info} >
          <InfoCircleOutlined />
        </CustomTooltip>
      </div>
      <div className="ui-risk__main__values">
        <div className={`ui-risk__main__values__current ui-risk__main__values__current--${risk.flag}`}>
          {risk.currentImpactPercent}%
        </div>
        <div className="ui-risk__main__values__prev">
          {risk.prevImpactPercent}% (Prev.)
        </div>
        <div className={`ui-risk__main__values__diff ui-risk__main__values__diff--${risk.currentStatus}`}>
          {
            statusSymbols[risk.currentStatus]
          }
          <span>
            {risk.differencePercent}%
          </span>
        </div>
      </div>
    </div>
    <div className={`ui-risk__factors ui-risk__factors--${expanded ? 'show' : 'hide'}`}>
      <Factors factors={risk.factors} type={risk.name} />
    </div>
  </div>
};
